// extracted by mini-css-extract-plugin
export default {"host":"StickyFooterBrazeBannerMobile_host__wvP0-","hostHidden":"StickyFooterBrazeBannerMobile_hostHidden__fbN4Q"};